import type { ImageObject } from '@/types/types';
import { request } from './client';
import type { ICompany } from '@/types/company';

export function fetchCompanies(parameters: object): Promise<{ data: ICompany[] }> {
  return request('GET', '/v1/account/companies', parameters);
}
export function fetchCompany(id: number, parameters?: object): Promise<{ data: ICompany }> {
  return request('GET', `/v1/account/companies/${id}`, parameters);
}
export function createCompany(body: Partial<ICompany>): Promise<{ data: ICompany }> {
  return request('POST', '/v1/account/companies', {}, body);
}
export function updateCompany(id: number, body: ICompany, parameters?: object): Promise<{ data: ICompany }> {
  return request('PUT', `/v1/account/companies/${id}`, parameters, body);
}
export function fetchCompanyImages(id: number, parameters?: object): Promise<{ data: ImageObject[] }> {
  return request('GET', `/v1/account/companies/${id}/images`, parameters);
}

export function fetchImageMeta(imageHash: string | number): Promise<{ data: ImageObject }> {
  return request('GET', `/v1/account/media/images/${imageHash}`, { meta: 1 });
}

export function createCompanyImage(companyId: string | number, addCompanyImage: ImageObject) {
  return request('POST', `/v1/account/companies/${companyId}/images`, {}, addCompanyImage);
}
export function deleteCompanyImage(companyId: string | number, deleteCompanyImageId: string | number) {
  return request('DELETE', `/v1/account/companies/${companyId}/images/${deleteCompanyImageId}`);
}
export function updateCompanyImages(companyId: string | number, ids: (string | number)[]) {
  return request('PUT', `/v1/account/companies/${companyId}/images`, {}, { ids });
}
